import React from 'react'
import { AiOutlineTag } from "@react-icons/all-files/ai/AiOutlineTag";
import { FaRegHandshake } from "@react-icons/all-files/fa/FaRegHandshake";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { AiOutlineCompass } from "@react-icons/all-files/ai/AiOutlineCompass";
import { AiOutlineClose } from "@react-icons/all-files/ai/AiOutlineClose";
import { AiOutlineCheck } from "@react-icons/all-files/ai/AiOutlineCheck";
import { AiOutlinePercentage } from "@react-icons/all-files/ai/AiOutlinePercentage";
const B2BTable = ({one, two, three, four}) => {

  return <section className='b2bTable'>
             <div className="upperBold">Compare Partnership Models</div>
    <div className="colTable">
        <div className="row head">
            <div className='firstCol'></div>
            {one && <div className='model'>
                <AiOutlineTag />
                <strong>White Label Partnership</strong>
                </div>}
            {two && <div className='model'>
                <FaRegHandshake />
                <strong>Audio Visual Partners</strong>
                </div>}
            {three && <div className='model'>
                <AiOutlineCompass />
                <strong>AV Compass</strong>
                </div>}
            {four && <div className='model'>
                <AiOutlinePercentage />
                <strong>Referral Discount Program</strong>
                </div>}
        </div>
        <div className="row odd">
            <div className='firstCol feature'>
                <strong>Service is provided as</strong>
            </div>
            {one && <div className='box'>
                Partner&apos;s Brand      
                </div>}
            {two && <div className='box'>
                Miami Sound Rental
                </div>}
            {three && <div className='box'>
                AV Compass
                </div>}
            {four && <div className='box'>
                Miami Sound Rental
                </div>}
        </div>
        <div className="row ">
            <div className='firstCol feature'>
            <strong>Partner has a designated Account Manager</strong>
             
            </div>
            {one && <div className='box'>
            <AiOutlineCheck className='green' />    
                </div>}
            {two && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {three && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {four && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
        </div>
        <div className="row odd">
            <div className='firstCol feature'>
            <strong>Partner receives a complimentary AV assessment and custom packages</strong>
 
            </div>
            {one && <div className='box'>
            <AiOutlineCheck className='green' />    
                </div>}
            {two && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {three && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {four && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
        </div>
        <div className="row ">
            <div className='firstCol feature'>
                <strong>Partner receives promotional material with their custom packages</strong>
            </div>
            {one && <div className='box'>
            <AiOutlineCheck className='green' />    
                </div>}
            {two && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {three && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {four && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
        </div>
        <div className="row odd">
            <div className='firstCol feature'>
                <strong>Partner has access to the Partner&apos;s Portal to track events and venue details</strong>
            </div>
            {one && <div className='box'>
            <AiOutlineCheck className='green' />    
                </div>}
            {two && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {three && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {four && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
        </div>
        <div className="row ">
            <div className='firstCol feature'>
                <strong>Service is billed directly to the client</strong>
            </div>
            {one && <div className='box'>
                <AiOutlineClose className='red' />            
                </div>}
            {two && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {three && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {four && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
        </div>
        <div className="row odd">
            <div className='firstCol feature'>
                <strong>Partner retains control over pricing</strong>
            </div>
            {one && <div className='box'>
                <AiOutlineCheck className='green' />      
                </div>}
            {two && <div className='box'>
                <AiOutlineClose className='red' />       
                </div>}
            {three && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {four && <div className='box'>
                <AiOutlineClose className='red' />       
                </div>}
        </div>
        <div className="row ">
            <div className='firstCol feature'>
                <strong>Partner Venue has a featured page on Miami Sound Rental</strong>
            </div>
            {one && <div className='box'>
                <AiOutlineClose className='red' />            
                </div>}
            {two && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
            {three && <div className='box'>
            <AiOutlineClose className='red' />      
                </div>}
            {four && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
        </div>
        <div className="row odd">
            <div className='firstCol feature'>
                <strong>Partner receives an automatic commission from each AV production</strong>
            </div>
            {one && <div className='box'>
                <AiOutlineClose className='red' />      
                </div>}
            {two && <div className='box'>
                <AiOutlineCheck className='green' />  
                </div>}
            {three && <div className='box'>
                <AiOutlineClose className='red' />      
                </div>}
            {four && <div className='box'>
                <AiOutlineClose className='red' />        
                </div>}
        </div>
        <div className="row ">
            <div className='firstCol feature'>
                <strong>Discounts are automatically added to each AV production</strong>
            </div>
            {one && <div className='box'>
                <AiOutlineCheck className='green' />      
                </div>}
            {two && <div className='box'>
                <AiOutlineClose className='red' />      
                </div>}
            {three && <div className='box'>
            <   AiOutlineCheck className='green' />
                </div>}
            {four && <div className='box'>
                <AiOutlineCheck className='green' />
                </div>}
        </div>

   


    </div>

  </section>
}

export default B2BTable